export * from './delete-besichtigung.component';
export * from './delete-besichtigung.component.module';